import InfoCardHeader from './InfoCardHeader';

export default InfoCardHeader;
